import { Constants } from '../../utils/constants';

export default function getApiImage(url: string) {
  return `${Constants.baseBackApiUrl}${url}`;
}
